<template>
  <ExternalList
      headline="Latest Partners"
      endpoint="/api/v1/subscription-periods?order_by=created_at&order_direction=desc&limit=10"
      :endpoint-filters="{project_id: project.id}"
      :default-page-size="0"
      :page-size-options="null"
      :headlines="headlines"
      :checkbox-column-width="2"
      :button-column-width="2"
      :can-show="() => true"
      :can-destroy="() => false"
      :show-buttons="false"
      :show-checkboxes="false"
      :show-list-actions="false"
      @show="ad => $router.push(getUrl(ad))"
  >
    <template v-slot:default="{ row: subscriptionPeriod }">
      <td class="table__ellipsis">
        <router-link :to="getUrl(subscriptionPeriod)">
          {{ subscriptionPeriod.subscription.subscriber.name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ subscriptionPeriod.created_at | date }}
      </td>

      <td class="table__ellipsis text-right">
        {{ subscriptionPeriod.price | price }}
      </td>
    </template>

    <template #headline-right>
      <router-link to="project-partners" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-search"></i> Show all
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../../Panels/Lists/External'

export default {
  components: { ExternalList},

  props: {
    project: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 12, text: 'Company'},
        {width: 6, text: 'Date'},
        {width: 6, text: 'Price', class: 'text-right'},
      ]
    }
  },

  methods:{
    getUrl(subscriptionPeriod) {
      return '/' + subscriptionPeriod.subscription.subscriber_type + '/' + subscriptionPeriod.subscription.subscriber_id + '/subscriptions/' + subscriptionPeriod.subscription.id
    }
  },
}
</script>
